import Image from "next/image";
import React, { useState } from "react";
import { RiArrowRightSLine } from "react-icons/ri";
import { UseCase } from "../../pages/resources/free-whatsapp-message-templates/index";
import { UseCaseIcon } from "./UseCaseIcon";
import { IoTriangleOutline } from "react-icons/io5";
import { industries, industryColorData, useCasesData } from "types/wa-message-templates";
import { Industry } from "types/wa-message-templates";

interface TemplateNavigatorProps {
    useCases: UseCase[];
}

const TemplateNavigator: React.FC<TemplateNavigatorProps> = ({ useCases }) => {
    const [industry, setIndustry] = useState<Industry>("Real Estate");
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const toggleDropdown = (item: string) => {
        setIndustry(item);
        setIsOpen(false);
    };
    const findTemplateLink = (industry: string, use_case: string) => {
        const match = useCases.find((item) => item.industry === industry && item.use_case === use_case);
        return match ? match.template_link : "#";
    };
    const handleClick = (item: string) => {
        setIndustry(item);
    };
    return (
        <div className="max-w-6xl mx-auto flex flex-col justify-between items-center lg:gap-14">
            <div className="flex flex-col items-center lg:mx-40 gap-4 mt-12">
                <h2 className="text-4xl font-semibold text-gray-800 text-center w-fit">Explore WhatsApp Business Message Templates</h2>
                <p className="text-base font-normal text-center lg:mx-16 px-2 text-gray-700">
                    Across 10 major industries and 10 most in-demand business applications to help you craft engaging user conversations
                </p>
            </div>
            <div className="mt-6 mb-4 lg:hidden">
                <h6 className="font-semibold text-xl mb-2  text-center">Industries</h6>
                <div className="relative w-60">
                    <button
                        className="flex items-center justify-between gap-3 py-2 px-4 cursor-pointer bg-gray-100 w-60 border-2 border-gray-300 border-solid rounded-lg"
                        onClick={() => setIsOpen(true)}
                    >
                        <div className="flex gap-3">
                            <Image src={industryColorData[industry]["blue-icon"]} alt={"logo"} width={24} height={24} />
                            <span
                                className="font-medium text-base"
                                style={{
                                    color: "#2B6CB0",
                                }}
                            >
                                {industry}
                            </span>
                        </div>
                        <IoTriangleOutline style={{ fontSize: "9px", color: "#4A5568", transform: "rotate(180deg)" }} />
                    </button>
                    {isOpen && (
                        <ul className="absolute left-0 w-64 bg-white shadow-lg mt-2 max-h-60 overflow-y-auto z-10">
                            {industries.map((option, index) => (
                                <li key={index} className="flex items-center gap-3 py-2 px-4 cursor-pointer hover:bg-gray-500" onClick={() => toggleDropdown(option)}>
                                    <Image src={industryColorData[option]["white-icon"]} alt={"logo"} width={24} height={24} />
                                    <span
                                        className="font-medium text-lg"
                                        style={{
                                            color: "#2D3748",
                                        }}
                                    >
                                        {option}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            </div>
            <div className="flex flex-col lg:flex-row justify-between mb-20 gap-24">
                <div className="flex-col gap-4 hidden lg:block">
                    <h6 className="font-semibold text-xl text-gray-700 pl-4 mb-4">Industries</h6>
                    <div>
                        {industries.map((item, idx) => (
                            <button
                                key={idx}
                                className={`flex gap-3 pl-4 pr-2 py-3 w-60 mt-2 rounded-lg ${industry === item ? "bg-blue-50 mb-2 text-white" : null}`}
                                onClick={() => handleClick(item)}
                            >
                                <Image src={industry === item ? industryColorData[item]["blue-icon"] : industryColorData[item]["white-icon"]} alt={"logo"} width={24} height={24} />
                                <span className="font-medium text-lg" style={{ color: industry === item ? "#2B6CB0" : "#2D3748" }}>
                                    {item}
                                </span>
                            </button>
                        ))}
                    </div>
                </div>
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-8 mx-1 lg:mx-0">
                    {useCasesData.map((item, idx) => (
                        <a
                            key={idx}
                            href={findTemplateLink(industry, item)}
                            className="flex flex-col bg-white rounded-lg overflow-hidden border-2 border-solid border-gray-100 w-44 lg:w-48 lg:h-56 h-52 cursor-pointer hover:shadow-lg hover:no-underline mb-4"
                        >
                            <div className="flex flex-col items-center gap-1 bg-yellow-100  h-full" style={{ background: industryColorData[industry]["usecase-color"] }}>
                                <div className="bg-white mt-4 mb-2 rounded-md p-2 shadow-md w-16 h-16 flex items-center justify-center">
                                    <UseCaseIcon strokeColor={industryColorData[industry]["stroke-color"]} usecase={item} />
                                </div>
                                <p className="font-semibold text-center text-lg text-gray-700 mx-3 lg:p-2">{item}</p>
                            </div>
                            <div className="flex p-3 justify-center items-center bg-white">
                                <a className="flex underline font-medium text-blue-500 text-base" data-cy={`usecase-${item}-view_template_link`}>
                                    View templates
                                </a>
                                <RiArrowRightSLine className="text-blue-500" size={20} />
                            </div>
                        </a>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default TemplateNavigator;
